module.exports = __webpack_public_path__ + "img/add-person_dark.3d678be7.svg";